import React, { useContext, useState, useEffect } from 'react'
import axios from 'axios'
import Layout from "../../components/layout"
import { ContactWrapper, ContactCardContainer, ContactImageContainer } from './style'
import { toAbsoluteUrl } from '../../utils/assetHelper'
import Input from "../../components/Input"
import { CountryDropdown, StateDropdown } from '../../components/DropDowns'
import Dropdown from "../../components/Dropdown"
import { contactApi } from '../../api'
import { AuthContext } from '../../context/auth'
import { Footer } from "../../components/Footer"
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

const Index = () => {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const { setNotification, setIsLoading } = useContext(AuthContext)
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [company, setCompany] = useState('');
    const [country, setCountry] = useState('United States');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [topic, setTopic] = useState();
    const [description, setDescription] = useState('');
    const [cities, setCities] = useState([]);

    const data = (new URL(document.location).searchParams)
    const support = data.get('support')

    useEffect(() => {
        if (support) {
            setTopic(support)
        }
    }, [support])



const sendContact = async () => {
  setIsLoading(true);

  if (!executeRecaptcha) {
    setNotification({ type: 'red', message: 'reCAPTCHA not ready. Please refresh.' });
    setIsLoading(false);
    return;
  }

  const token = await executeRecaptcha('contact_form').catch(() => null);

  if (!token) {
    setNotification({ type: 'red', message: 'reCAPTCHA failed. Please try again.' });
    setIsLoading(false);
    return;
  }

  const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  if (!email || !isValidEmail) {
    setNotification({ type: 'red', message: 'Please enter a valid Email Address' });
    setIsLoading(false);
    return;
  }

  const data = {
    first_name: firstName,
    last_name: lastName,
    email,
    company,
    country,
    state,
    city,
    topic,
    message: description,
    email_to: 'contact@identifyn.com',
    token
  };

  try {
    const response = await contactApi(data);

    if (response?.status === 200) {
      setFirstName('');
      setLastName('');
      setEmail('');
      setCompany('');
      setTopic('');
      setDescription('');
      setNotification({ type: 'success', message: 'Message sent successfully!' });
    } else {
      throw new Error();
    }
  } catch {
    setNotification({ type: 'red', message: 'Something went wrong. Please try again.' });
  } finally {
    setIsLoading(false);
  }
};



    useEffect(() => {
        if (state === undefined) return
        if (state) {
            setIsLoading(true)
            axios.post('https://countriesnow.space/api/v0.1/countries/state/cities', {
                country: country,
                state: state
            }).then((res) => {
                setCities(res.data.data)
                setCity(res.data.data[0])
            }).catch((err) => {
                const errMsg = err?.response?.data?.msg
                if (errMsg === 'state not found') {
                    setCities([state])
                    setCity(state)
                } else {
                    setCities([])
                    setCity()
                }
            }).finally(() => {
                setIsLoading(false)
            })
        }
    }, [state])





    return (
        <Layout>
            <ContactImageContainer>
                <div className="bruker-image-grid">
                    <img src={toAbsoluteUrl("/media/bruker/bruker7.jpg")} alt="" />
                    <div className='image-grid-column'>
                        <img src={toAbsoluteUrl("/media/bruker/bruker8.gif")} alt="" />
                        <img src={toAbsoluteUrl("/media/bruker/bruker9.gif")} alt="" />
                    </div>
                </div>
            </ContactImageContainer>
            <ContactWrapper>
                <div className="left-container">
                    <div className="solutions-text">
                        <h2 style={{ width: '100%' }}>Contact <span>Us</span></h2>
                        <p>Please contact Identifyn® using this form. </p>
                        <p>Select topic from dropdown and briefly describe how we can help.
                        </p>
                    </div>
                </div>
                <div className="right-container">
                    <div className="form-container">
                        <div className="form-wrapper">
                            <div
                                style={{ display: "block", width: "100%", marginTop: "20px", marginBottom: '20px' }}
                            >
                                <div className="two-column">
                                    <Input placeholder="Your First Name" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                    <Input placeholder="Your Last Name" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                </div>
                                <Input placeholder="Your Email" type='email' style={{ marginBottom: '20px' }} value={email} onChange={(e) => setEmail(e.target.value)} />
                                <Input placeholder="Your Company/Institution" style={{ marginBottom: '20px' }} optional value={company} onChange={(e) => setCompany(e.target.value)} />
                                <div className="three-column">
                                    <CountryDropdown value={country} onChange={(value) => {
                                        setCountry(value)
                                        setState('')
                                        setCities([])
                                        setCity('')
                                    }} />
                                    <StateDropdown value={state} country={country} placeholder={"State"} onChange={(value) => {
                                        setState(value)
                                        setCities([])
                                        setCity('')
                                    }} />
                                    <select
                                        value={city}
                                        onChange={(e) => {
                                            setCity(e.target.value)
                                        }}
                                        placeholder='City'
                                    >
                                        <option disabled selected>City </option>
                                        {cities && cities.length && cities?.map((city) => {
                                            return <option key={city} value={city}>{city}</option>
                                        })}
                                    </select>
                                </div>
                                <Dropdown
                                    value={topic}
                                    onChange={(e) => {
                                        setTopic(e)
                                    }}
                                    style={{ marginBottom: '20px', width: '100%' }}
                                    label={'Select Topic'}
                                    optionType='array'
                                    options={
                                        [
                                            "Purchase Identifyn® Reagents",
                                            "Microscopy Support",
                                            "Protein Chemistry Support",
                                            "Primary Antibody",
                                            "Primary Fluorescent Conjugates",
                                            "Secondary Fluorescent Conjugates",
                                            "Assays Inquiry",
                                            "Service Inquiry",
                                            "General Inquiry"
                                        ]
                                    }
                                />
                                <textarea
                                    style={{ resize: "none", borderRadius: "8px" }}
                                    placeholder='Write your message here!'
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                ></textarea>
                            </div>
                            <button class="btn" style={{ float: 'right' }}
                                disabled={!firstName || !lastName || !email || !country || !state || !city || !topic || !description}
                                onClick={sendContact}
                            >Get In Touch!</button>
                        </div>
                    </div>
                </div>
            </ContactWrapper>
            <ContactCardContainer>
                <div className="card">
                    <span style={{ width: '44px', height: '44px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', background: '#fff2e5', color: 'var(--primary-color)' }}>
                        <i class="far fa-mobile"></i>
                    </span>
                    <h5>Phone Number</h5>
                    <h4>941.529.0647</h4>
                </div>
                <div className="card">
                    <span style={{ width: '44px', height: '44px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', background: '#fff2e5', color: 'var(--primary-color)' }}>
                        <i class="fal fa-microscope"></i>
                    </span>
                    <h5>Laboratory Address </h5>
                    <h4>2055 Wood Street, Suite 102 Sarasota, FL 34237</h4>
                </div>
                <div className="card">
                    <span style={{ width: '44px', height: '44px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', background: '#fff2e5', color: 'var(--primary-color)' }}>
                        <i class="far fa-building"></i>
                    </span>
                    <h5>Corporate Address</h5>
                    <h4>2055 Wood Street, Suite 206 Sarasota, FL 34237</h4>
                </div>
            </ContactCardContainer>
            <Footer />
        </Layout>
    )
}

export default Index